module.exports = __webpack_public_path__ + "static/media/Darmanitan_gaussian2.2523b9b8.png";